import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/layout/breadcrumbs.css';

export interface BreadcrumbItem {
  label: string;
  path?: string;
  isActive?: boolean;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = '' }) => {
  const navigate = useNavigate();

  const handleClick = (item: BreadcrumbItem) => {
    if (item.path && !item.isActive) {
      navigate(item.path);
    }
  };

  return (
    <nav className={`breadcrumbs ${className}`} aria-label="Breadcrumb navigation">
      <ol className="breadcrumbs-list">
        {items.map((item, index) => (
          <li key={index} className="breadcrumb-item">
            {item.path && !item.isActive ? (
              <button
                type="button"
                className="breadcrumb-link"
                onClick={() => handleClick(item)}
                aria-label={`Navigate to ${item.label}`}
              >
                {item.label}
              </button>
            ) : (
              <span 
                className={`breadcrumb-text ${item.isActive ? 'active' : ''}`}
                aria-current={item.isActive ? 'page' : undefined}
              >
                {item.label}
              </span>
            )}
            {index < items.length - 1 && (
              <span className="breadcrumb-separator" aria-hidden="true">
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                  <path 
                    d="M1 1L5 5L1 9" 
                    stroke="currentColor" 
                    strokeWidth="1.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;